require.register("ffss/component/row/CompetitionDetail", function(exports, require, module){
  $0
  
});

